import i18next from 'i18next';

i18next.addResources('es', 'investmentProgress', {
  investmentByStage: 'Inversión por etapas'
});
